"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _RetailPriceChartContainer = _interopRequireDefault(require("../RetailPriceChart/RetailPriceChartContainer"));
var _InstrumentTableContainer = _interopRequireDefault(require("../InstrumentTable/InstrumentTableContainer"));
var _InstrumentSelectorContainer = _interopRequireDefault(require("../InstrumentSelector/InstrumentSelectorContainer"));
var _FuturesInstrumentSelectorContainer = _interopRequireDefault(require("../FuturesInstrumentSelector/FuturesInstrumentSelectorContainer"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _selectors = require("../../redux/futures/selectors");
require("./MarketOverviewComponent.css");
var _FuturesInstrumentTableContainer = _interopRequireDefault(require("../FuturesInstrumentTable/FuturesInstrumentTableContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var marketOverviewClasses = (0, _cssClassesHelper.getBEMClasses)('market-overview');
var MarketOverviewComponent = function MarketOverviewComponent() {
  var isFuturesActive = (0, _reactRedux.useSelector)(_selectors.isFuturesActiveSelector);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: marketOverviewClasses('body')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: marketOverviewClasses('chart-component-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: marketOverviewClasses('instrument-selector')
  }, isFuturesActive ? /*#__PURE__*/_react["default"].createElement(_FuturesInstrumentSelectorContainer["default"], {
    customClass: "market-overview-popup",
    showFullNameInstrument: true,
    showTriangles: true
  }) : /*#__PURE__*/_react["default"].createElement(_InstrumentSelectorContainer["default"], {
    customClass: "market-overview-popup",
    showFullNameInstrument: true,
    showTriangles: true
  })), /*#__PURE__*/_react["default"].createElement(_RetailPriceChartContainer["default"], {
    customClass: marketOverviewClasses('retail-price-chart-container')
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: marketOverviewClasses('market-overview-container')
  }, isFuturesActive ? /*#__PURE__*/_react["default"].createElement(_FuturesInstrumentTableContainer["default"], {
    marketOverview: true
  }) : /*#__PURE__*/_react["default"].createElement(_InstrumentTableContainer["default"], {
    customClass: "market-overview-instrument"
  })));
};
var _default = exports["default"] = MarketOverviewComponent;